<div
  [ngClass]="{
    'content-wide': width === 'wide',
    'content-full': width === 'full',
  }"
>
  <ng-content select=".top-of-page"></ng-content>
  <ng-content select="app-breadcrumbs"></ng-content>
  <ng-content select="gax-breadcrumbs"></ng-content>
  <ng-content select="gax-page-back-link"></ng-content>

  <div class="header-container">
    <ng-content select="gax-page-header"></ng-content>
  </div>

  <ng-content></ng-content>
</div>

<!-- Page Footer - always full width-->
<ng-content select="gax-page-footer" class="full-width"></ng-content>
